export const backendUrl = 'https://backend.abelling.ai/'
export const spacesBucketUrl =' https://abelling-ai.lon1.digitaloceanspaces.com/'
